/**
 * EnrollmentPage
 *
 * Full-page enrollment wizard for biometric setup.
 *
 * FERP-PII-052: User enrollment for WebAuthn PRF protection.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Stack, Text, Center } from '@mantine/core';

import { EnrollmentWizard } from '../enrollment';

export const EnrollmentPage: React.FC = () => {
  const navigate = useNavigate();

  const handleComplete = () => {
    navigate('/ferp-core/dashboard');
  };

  const handleSkip = () => {
    navigate('/ferp-core/dashboard');
  };

  return (
    <Container size="md" py="xl">
      <EnrollmentWizard
        onComplete={handleComplete}
        onSkip={handleSkip}
        allowSkip={true}
      />
    </Container>
  );
};

export default EnrollmentPage;
